import { createReducer, on } from '@ngrx/store';
import { setLookback } from './lookback.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const lookback = createReducer(null, on(setLookback, (state, action) => {
    return action.lookback;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.lookback !== undefined ? action.scatterPlot.lookback : state;
}));
